/**
 * Agent Context Kit (agentcontextkit.com) — the one-time $149 tool that comes
 * included with the paid membership. It lives on its own domain and sells
 * itself as a standalone tool there; members reach it from the dashboard
 * already signed in and unlocked (server/lib/partner-handoff.ts).
 *
 * Display facts only. Nothing here is secret.
 */

import { PARTNERS } from "./partners";

/** The paid membership's name, everywhere a customer can read it. Was "AdVenture Pro" until 2026-09-30. */
export const PLUS_NAME = "AdVenture Plus";

/**
 * What AdVenture Plus is, in one line. Sits under the name on /membership and
 * /promo, and in the nav, the auth pages, the page meta and the badge share
 * text. Patrick, 2026-10-01: say what the platform is for. "Training", not
 * "education and training": one word, the one that implies doing. Changing
 * the word is this one edit.
 */
export const PLUS_TAGLINE = "The membership for ongoing AI training.";
/** The same idea mid-sentence: "AdVenture Plus, ongoing AI training for ...". */
export const PLUS_DESCRIPTOR = "ongoing AI training";

export const ACK_NAME = "AI Context Toolkit";
export const ACK_HOST = "agentcontextkit.com";
export const ACK_URL = `https://${ACK_HOST}`;

/** The kit's standalone price on its own site. Change together with ACK's src/lib/pricing.ts. */
export const ACK_PRICE_DOLLARS = 149;

/**
 * Where "Open your kit" goes. Since 2026-10-27 the kit runs inside the site
 * (client/src/pages/kit), so it's a page, not the partner handoff.
 */
export const ACK_LAUNCH_PATH = "/kit";
/** Where someone new starts: the interview. */
export const ACK_START_PATH = "/kit/build";
/** sessionStorage key: a company website typed into the toolkit pop-up, which
 *  the interview takes once as its first answer (BuildFlow), then clears. */
export const ACK_PREFILL_KEY = "ack:prefillCompany";

export const ACK_SUMMARY =
  "The files Claude reads before every draft, built from research on your company and your own writing, so it knows your business and writes like you.";

/** What the kit contains, in the order ACK's own site lists it. */
export const ACK_CONTENTS: ReadonlyArray<{ file: string; body: string }> = [
  { file: "CLAUDE.md", body: "Your business in words you picked: what you sell, who buys, what you call things, what you are never allowed to claim." },
  { file: "VOICE.md", body: "How you actually write, taken from your own sentences." },
  { file: "SLOP.md", body: "The sixteen patterns that make writing read as AI, with a fix for each." },
  { file: "BRAND.md", body: "For founders and marketers, for writing published as the company." },
  { file: "Sound like you", body: "Draft with your files, mark what is off, and update VOICE.md." },
];
